import { axiosClient } from '@/shared/apis/config';
import { ApiResponse } from '@/shared/types';
import { useMutation } from '@tanstack/react-query';
import {
  GtsVideoGenerateRequest,
  GtsVideoGenerateResponse,
} from '@/features/gts/model/gts-types';

export type PostProjectVideoGenerateResponse =
  ApiResponse<GtsVideoGenerateResponse>;

export const postProjectVideoGenerateApi = async (
  projectId: number,
  request: GtsVideoGenerateRequest,
): Promise<PostProjectVideoGenerateResponse> => {
  const response = await axiosClient.post<PostProjectVideoGenerateResponse>(
    `/v1.0/project/${projectId}/video/generate`,
    request,
  );
  return response.data;
};

export const usePostProjectVideoGenerate = (projectId: number) => {
  return useMutation({
    mutationFn: (request: GtsVideoGenerateRequest) =>
      postProjectVideoGenerateApi(projectId, request),
  });
};
